import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import Stories from 'react-insta-stories';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CancelIcon from '@mui/icons-material/Cancel';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { CircleSpinner } from 'react-spinners-kit';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Page from '../components/Page';
import { SharePostForm } from '../components/_dashboard/user';
import PostCard from '../components/_dashboard/user/PostCard';
import Modal from '../components/_dashboard/user/Modal';
import Loader from '../components/_dashboard/user/Loader';

const useStyles = makeStyles((theme) => ({
  slickCustom: {
    backgroundColor: 'yellow'
  },
  image: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'red',
    width: '80px',
    height: '80px',
    borderRadius: '100%',
    margin: '0px !important'
  },
  titleStory: {
    width: '100%',
    fontSize: '25px'
  },
  BUTTON_WRAPPER_STYLES: {
    position: 'relative',
    zIndex: 1
  },
  InputPost: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    width: '100%',
    height: '80px',
    borderRadius: '25px',
    cursor: 'pointer',
    paddingLeft: 20,
    marginTop: 20,
    '&:hover': {
      backgroundColor: '#ebe8e8'
    }
  },
  textInputPost: {
    fontSize: '15px',
    color: 'grey'
  }
}));
const API_ENDPOINT = process.env.REACT_APP_BASE_URL;

export default function Archive() {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const [dataShare, setDataShare] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop ===
        document.scrollingElement.scrollHeight ||
      isFetching
    )
      return;
    setIsFetching(true);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isFetching && result.next != null) {
      loadMoreArchive();
    }
  }, [isFetching]);

  const toggleModal = (data) => {
    setIsOpen(!isOpen);
    setDataShare(data);
    console.log('bbbbbbbbbbbb', dataShare);
  };

  // LIKE FUNTION
  const likeOrDislike = (pk) => {
    const data = { pk_post: pk };
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios
      .post(`${API_ENDPOINT}/api/like-post-from-actuality/`, data, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        console.log('response -->', response.data);
      });
  };

  // GET all Retrieve Archive
  const retrieveArchive = async () => {
    setIsLoading(true);
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios
      .get(`${API_ENDPOINT}/api/own-posts/`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        setIsLoading(false);
        console.log('get -->', response.data);
        setData(response.data.results);
        setResult(response.data);
      })
      .catch((err) => {
        console.log('error archive get', err);
      });
  };

  // LOAD MORE ARCHIVE
  const loadMoreArchive = () => {
    const token = localStorage.getItem('access');
    axios
      .get(`${result.next}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        console.log('get -->', response.data);
        setResult(response.data);
        setData((oldData) => [...oldData, ...response.data.results]);
        setIsFetching(false);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    retrieveArchive();
  }, []);

  return (
    <Page title={t('vosarchives')}>
      <Container style={{ backgroundColor: 'white', width: '80%' }}>
        <Loader load={isLoading} />
        <Stack direction="column" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('vosarchives')}
          </Typography>
        </Stack>
        <Stack direction="column" spacing={3} alignItems="center" mb={5}>
          {data.map((row) => (
            <PostCard
              row={row}
              likeFunction={likeOrDislike}
              shareFunction={() => toggleModal(row)}
              data={data}
              setData={setData}
            />
          ))}
          {isFetching && result.next != null && (
            <Box display="flex" justifyContent="center" sx={{ p: 3 }}>
              <CircleSpinner size={30} color="#ec8181" loading={isFetching} />
            </Box>
          )}
        </Stack>
        <Modal show={isOpen} onClose={toggleModal}>
          <Typography
            align="left"
            style={{ width: '100%', color: '#EC8B8B' }}
            variant="h4"
            gutterBottom
          >
            {t('sharepost')}
          </Typography>
          <SharePostForm row={dataShare} cancel={toggleModal} />
        </Modal>
      </Container>
    </Page>
  );
}
